var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHolisticApplication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18321.074,
    height: 14905.197,
    viewBox: "0 0 18321.074 14905.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616",
    transform: "translate(21338.076 -5963)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(-13411.719 12918.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1488",
    "data-name": "Group 1488",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M178.6,6046.5H5690.439V-415.087H178.6V6046.5",
    transform: "translate(795.431 438.581)",
    fill: "#f7665f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M137.135,6068.726V442.756c.156-466.436,426.606-844.989,957.836-857.782v-1.332h4.992c3.869,0,7.583.469,11.451.493l3.4-.173v.32c537.221,7.026,970.379,388.488,970.379,858.72V6068.726H137.135",
    transform: "translate(5371.055 416.357)",
    fill: "#d34040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M372.5,6068.726V442.756c.156-466.436,426.606-844.989,957.836-857.782v-1.332h4.993c3.868,0,7.613.469,11.451.493l3.4-.173v.32c537.22,7.026,970.38,388.488,970.38,858.72V6068.726H372.5",
    transform: "translate(-372.505 416.357)",
    fill: "#f7665f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M148.62,5775.449V348.148C148.713-89.3,464.3-386.35,857.363-398.357v-1.232h3.682c2.871,0,5.648.444,8.487.468l2.527-.172v.319c397.495,6.558,718.011,287.662,718.011,728.682V5775.449H148.62",
    transform: "translate(5597.397 709.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M312.527,5128.713V-362.608H197.045V5128.713H312.527",
    transform: "translate(5741.681 1356.371)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M302.761,5128.713V-362.608H187.28V5128.713H302.761",
    transform: "translate(5979.977 1356.371)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M292.965,5128.713V-362.608H177.514V5128.713H292.965",
    transform: "translate(6218.303 1356.371)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M283.231,5128.713V-362.608H167.749V5128.713H283.231",
    transform: "translate(6456.568 1356.371)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M273.434,5128.713V-362.608H157.984V5128.713H273.434",
    transform: "translate(6694.894 1356.371)",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487",
    transform: "translate(581.154 2653.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M381.737,3558.4V234.711c.093-275.558,252.056-499.173,565.9-506.742v-.789h2.932l6.771.271,2.028-.074v.173c317.365,4.142,573.26,229.508,573.26,507.309V3558.4H381.736",
    transform: "translate(-381.736 272.819)",
    fill: "#723950"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1486",
    "data-name": "Group 1486",
    transform: "translate(569.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M242.685,3558.4V234.711c.094-275.558,252.026-499.173,565.865-506.742v-.789h2.964l6.74.271,2.028-.074v.173c317.365,4.142,573.26,229.508,573.26,507.309V3558.4H242.685",
    transform: "translate(2441.921 272.819)",
    fill: "#54293a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1484",
    "data-name": "Group 1484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M266.927,3558.4H3535.059V-272.819H266.927V3558.4",
    transform: "translate(-266.927 272.819)",
    fill: "#723950"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "M249.47,3394.125V163.32c.063-259.114,186.5-418.907,418.712-426.032v-.714h2.184l4.992.246,1.5-.074v.172c234.833,3.9,424.172,165.191,424.172,426.4V3394.125H249.47",
    transform: "translate(2575.643 437.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M346.319,3001.56V-240.98H278.078V3001.56h68.241",
    transform: "translate(2660.864 829.664)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "M340.519,3001.56V-240.98h-68.21V3001.56h68.21",
    transform: "translate(2801.678 829.664)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M334.78,3001.56V-240.98H266.54V3001.56h68.24",
    transform: "translate(2942.431 829.664)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "M329.011,3001.56V-240.98H260.771V3001.56h68.241",
    transform: "translate(3083.216 829.664)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M323.241,3001.56V-240.98H255V3001.56h68.24",
    transform: "translate(3224.001 829.664)",
    fill: "#ededed"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610",
    transform: "translate(-1053.877 466.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609",
    transform: "translate(-16338.574 7324.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607",
    transform: "translate(740.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1529",
    "data-name": "Group 1529",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1528",
    "data-name": "Group 1528",
    transform: "translate(7597.983 1859.518)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_461",
    "data-name": "Ellipse 461",
    cx: 304.5,
    cy: 306,
    rx: 304.5,
    ry: 306,
    transform: "translate(0.045 -0.11)",
    fill: "none",
    stroke: "#357d93",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    strokeDasharray: "11.666 11.666"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 1128,
    x2: 2273,
    transform: "translate(8207.028 1035.407)",
    fill: "none",
    stroke: "#357d93",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 918,
    y1: 1716,
    transform: "translate(6881.028 93.407)",
    fill: "none",
    stroke: "#357d93",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x1: 1905,
    y2: 1691,
    transform: "translate(3942.029 0.407)",
    fill: "none",
    stroke: "#357d93",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4109",
    "data-name": "Path 4109",
    d: "M315,253l1752.664,823.4L1369,2565.552",
    transform: "translate(1743.498 711.405)",
    fill: "none",
    stroke: "#357d93",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 924.712,
    y2: 336.37,
    transform: "translate(0 3434.602)",
    fill: "none",
    stroke: "#357d93",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 3782.519,
    y2: 1712.611,
    transform: "translate(8151.649 2375.946)",
    fill: "none",
    stroke: "#357d93",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: 774,
    y2: 1996,
    transform: "translate(12082.028 2471.407)",
    fill: "none",
    stroke: "#357d93",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    strokeDasharray: 12
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_462",
    "data-name": "Ellipse 462",
    cx: 188.5,
    cy: 186.5,
    rx: 188.5,
    ry: 186.5,
    transform: "translate(3622.029 1598.407)",
    fill: "#357d93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1533",
    "data-name": "Group 1533",
    transform: "translate(0 2823.135)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_463",
    "data-name": "Ellipse 463",
    cx: 422.5,
    cy: 424,
    rx: 422.5,
    ry: 424,
    transform: "translate(0.451 0.273)",
    fill: "#357d93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1532",
    "data-name": "Group 1532",
    transform: "translate(208.709 213.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1530",
    "data-name": "Group 1530",
    transform: "translate(167.634 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 94,
    height: 422,
    transform: "translate(0.107 0.121)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1531",
    "data-name": "Group 1531",
    transform: "translate(0 163.193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 425,
    height: 93,
    transform: "translate(-0.259 -0.072)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1537",
    "data-name": "Group 1537",
    transform: "translate(12468.198 2068.227)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 424,
    cy: 423,
    rx: 424,
    ry: 423,
    transform: "translate(0.253 0.18)",
    fill: "#357d93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1536",
    "data-name": "Group 1536",
    transform: "translate(214.261 213.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1534",
    "data-name": "Group 1534",
    transform: "translate(164.303 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 90,
    height: 426,
    transform: "translate(-0.311 0.029)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1535",
    "data-name": "Group 1535",
    transform: "translate(0 162.084)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 422,
    height: 96,
    transform: "translate(-0.008 -0.055)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(-15802.368 5497.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle_Grid",
    "data-name": "Circle Grid",
    transform: "translate(5383.163 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_486",
    "data-name": "Ellipse 486",
    cx: 1225,
    cy: 1224.5,
    rx: 1225,
    ry: 1224.5,
    transform: "translate(0.082 -0.271)",
    fill: "#8db1cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "test_2_",
    "data-name": "test (2)",
    transform: "translate(0 784.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1561",
    "data-name": "Group 1561",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1560",
    "data-name": "Group 1560",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1559",
    "data-name": "Group 1559",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1558",
    "data-name": "Group 1558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1557",
    "data-name": "Group 1557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1556",
    "data-name": "Group 1556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1555",
    "data-name": "Group 1555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1554",
    "data-name": "Group 1554"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_485",
    "data-name": "Ellipse 485",
    cx: 1303,
    cy: 1306.5,
    rx: 1303,
    ry: 1306.5,
    transform: "translate(0.245 -0.154)",
    fill: "#fe6a16"
  }))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4147",
    "data-name": "Path 4147",
    d: "M2087.6,989.769a1319.732,1319.732,0,0,0-7.251-138.384L1305.967,77l-26.235,267.579L1012.158,77l-25.6,268.206L718.348,77,688.283,340.744,424.539,77l-296.9,1844.43,334.14,334.14a1308.074,1308.074,0,0,0,320.407,39.611C1503.146,2295.181,2087.6,1710.728,2087.6,989.769Z",
    transform: "translate(520.717 318.128)",
    fill: "#e83b05"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1562",
    "data-name": "Group 1562",
    transform: "translate(648.35 524.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4148",
    "data-name": "Path 4148",
    d: "M127.638,102.295h1309.1V1817.734H127.638Z",
    transform: "translate(-127.638 -102.295)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1563",
    "data-name": "Group 1563",
    transform: "translate(1303.514 524.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4149",
    "data-name": "Path 4149",
    d: "M256.12,102.295H910.055V1817.734H256.12Z",
    transform: "translate(-256.12 -102.295)",
    fill: "#e9edf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1568",
    "data-name": "Group 1568",
    transform: "translate(779.121 395.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1564",
    "data-name": "Group 1564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4150",
    "data-name": "Path 4150",
    d: "M153.283,77H319.412V334.977H153.283Z",
    transform: "translate(-153.283 -77)",
    fill: "#ffce00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1565",
    "data-name": "Group 1565",
    transform: "translate(293.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4151",
    "data-name": "Path 4151",
    d: "M210.9,77H377.03V334.977H210.9Z",
    transform: "translate(-210.901 -77)",
    fill: "#ffce00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1566",
    "data-name": "Group 1566",
    transform: "translate(587.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4152",
    "data-name": "Path 4152",
    d: "M268.519,77H434.648V334.977H268.519Z",
    transform: "translate(-268.519 -77)",
    fill: "#fdba12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1567",
    "data-name": "Group 1567",
    transform: "translate(881.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4153",
    "data-name": "Path 4153",
    d: "M326.137,77H492.266V334.977H326.137Z",
    transform: "translate(-326.137 -77)",
    fill: "#fdba12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569",
    transform: "translate(1366.74 976.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4154",
    "data-name": "Path 4154",
    d: "M268.519,190.948H754.347V343.926H268.519Z",
    transform: "translate(-268.519 -190.948)",
    fill: "#cdd2e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570",
    transform: "translate(770.539 790.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4155",
    "data-name": "Path 4155",
    d: "M338.381,553.582,151.6,366.8,259.771,258.625l78.61,78.61L521.032,154.585,629.2,262.756Z",
    transform: "translate(-151.6 -154.585)",
    fill: "#7e8596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1571",
    "data-name": "Group 1571",
    transform: "translate(1366.74 1406.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4156",
    "data-name": "Path 4156",
    d: "M268.519,275.239H754.347V428.217H268.519Z",
    transform: "translate(-268.519 -275.239)",
    fill: "#cdd2e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572",
    transform: "translate(770.539 1220.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4157",
    "data-name": "Path 4157",
    d: "M338.381,637.873,151.6,451.087,259.771,342.916l78.61,78.61,182.651-182.65L629.2,347.047Z",
    transform: "translate(-151.6 -238.876)",
    fill: "#7e8596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573",
    transform: "translate(1366.74 1835.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4158",
    "data-name": "Path 4158",
    d: "M268.519,359.53H754.347V512.508H268.519Z",
    transform: "translate(-268.519 -359.53)",
    fill: "#cdd2e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1574",
    "data-name": "Group 1574",
    transform: "translate(770.539 1650.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4159",
    "data-name": "Path 4159",
    d: "M338.381,722.16,151.6,535.374,259.771,427.2l78.61,78.61L521.032,323.168,629.2,431.339Z",
    transform: "translate(-151.6 -323.168)",
    fill: "#7e8596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "exam",
    transform: "translate(9839.205 42.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1578",
    "data-name": "Group 1578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1577",
    "data-name": "Group 1577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4188",
    "data-name": "Path 4188",
    d: "M1385.874.018c769.251,3.864,1395.986,630.6,1399.85,1399.851s-616.6,1389.721-1385.856,1385.856S3.882,2155.126.018,1385.874,616.622-3.846,1385.874.018Z",
    transform: "translate(0 1969.52) rotate(-45)",
    fill: "#ffce00"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    "data-name": "Path 4175",
    d: "M2213.834,846.948l-708.286-701.2L130.245,1711.657l389.1,385.208a1418.672,1418.672,0,0,0,298.551,31.588c737.656,0,1342.052-564.855,1395.94-1281.505Z",
    transform: "translate(1151.926 1226.923)",
    fill: "#ffa300"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582",
    transform: "translate(1282.172 1000.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4176",
    "data-name": "Path 4176",
    d: "M1129.58,76.992,1505.543,449.2V2015.112H130.245V76.992Z",
    transform: "translate(-130.245 -76.992)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1583",
    "data-name": "Group 1583",
    transform: "translate(1970.482 1000.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4177",
    "data-name": "Path 4177",
    d: "M943.108,449.2,567.145,76.992H256.121V2015.111H943.108Z",
    transform: "translate(-256.121 -76.992)",
    fill: "#e9edf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1584",
    "data-name": "Group 1584",
    transform: "translate(2281.505 1000.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4178",
    "data-name": "Path 4178",
    d: "M313,449.2V76.992L688.969,449.2Z",
    transform: "translate(-313 -76.992)",
    fill: "#bec3d2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1585",
    "data-name": "Group 1585",
    transform: "translate(1475.417 1246.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4189",
    "data-name": "Path 4189",
    d: "M426.528,0c235.941.376,427.514,193.781,427.89,431.982S663.831,862.978,427.89,862.6.377,668.82,0,430.62,190.587-.376,426.528,0Z",
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 0, 843.311)",
    fill: "#ff6c52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1586",
    "data-name": "Group 1586",
    transform: "translate(1970.482 1310.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4179",
    "data-name": "Path 4179",
    d: "M686.87,561.271c0-235.661-192.791-426.725-430.749-427.082V988.347C494.074,988,686.87,796.937,686.87,561.271Z",
    transform: "translate(-256.121 -134.189)",
    fill: "#ff432e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1587",
    "data-name": "Group 1587",
    transform: "translate(1667.365 1503.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4180",
    "data-name": "Path 4180",
    d: "M492.092,544.517,473.746,492.78H327.489l-18.357,51.737H200.688L340.274,185.066H460.393L600.537,544.517ZM400.331,276.679,353.058,411.946H447.6Z",
    transform: "translate(-200.688 -103.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4181",
    "data-name": "Path 4181",
    d: "M426.759,326.245v104H362.251v-104H268.822V269.663h93.429v-99.7h64.508v99.7h93.429v56.587H426.759Z",
    transform: "translate(103.746 -169.963)",
    fill: "#e9edf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588",
    transform: "translate(1471.424 2276.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4182",
    "data-name": "Path 4182",
    d: "M164.855,312.756H316.279V475.161H164.855Z",
    transform: "translate(-164.855 -312.756)",
    fill: "#555a66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589",
    transform: "translate(1721.593 2276.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4183",
    "data-name": "Path 4183",
    d: "M210.605,312.756H928.963V475.161H210.605Z",
    transform: "translate(-210.605 -312.756)",
    fill: "#dce1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1590",
    "data-name": "Group 1590",
    transform: "translate(1970.482 2276.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4184",
    "data-name": "Path 4184",
    d: "M256.121,312.756H725.6V475.161H256.121Z",
    transform: "translate(-256.121 -312.756)",
    fill: "#bec3d2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1591",
    "data-name": "Group 1591",
    transform: "translate(1471.424 2588.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4185",
    "data-name": "Path 4185",
    d: "M164.855,370.421H316.279v162.4H164.855Z",
    transform: "translate(-164.855 -370.421)",
    fill: "#555a66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1592",
    "data-name": "Group 1592",
    transform: "translate(1721.593 2588.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4186",
    "data-name": "Path 4186",
    d: "M210.605,370.421H928.963v162.4H210.605Z",
    transform: "translate(-210.605 -370.421)",
    fill: "#dce1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1593",
    "data-name": "Group 1593",
    transform: "translate(1970.482 2588.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4187",
    "data-name": "Path 4187",
    d: "M256.121,370.421H725.6v162.4H256.121Z",
    transform: "translate(-256.121 -370.421)",
    fill: "#bec3d2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "edit_1_",
    "data-name": "edit (1)",
    transform: "translate(1035.779 4606.051)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_487",
    "data-name": "Ellipse 487",
    cx: 1283,
    cy: 1281.5,
    rx: 1283,
    ry: 1281.5,
    transform: "translate(0.465 -0.322)",
    fill: "#d888c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4190",
    "data-name": "Path 4190",
    d: "M2221.451,952.754a1289.232,1289.232,0,0,0-22.627-240.581L1791.806,305.155l-12.651,50.976L1505.288,82.265,85.75,1600.354,698.2,2212.8a1288.788,1288.788,0,0,0,240.576,22.626C1647.179,2235.427,2221.451,1661.156,2221.451,952.754Z",
    transform: "translate(344.749 328.25)",
    fill: "#b2519b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 1706.056,
    height: 1295.199,
    transform: "translate(430.499 633.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    width: 1706.056,
    height: 651.057,
    transform: "translate(430.499 1277.547)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    width: 855.533,
    height: 1295.199,
    transform: "translate(1281.021 633.405)",
    fill: "#ebebf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    width: 855.533,
    height: 651.057,
    transform: "translate(1281.021 1277.547)",
    fill: "#d2d2d7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1594",
    "data-name": "Group 1594",
    transform: "translate(554.507 868.896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_811",
    "data-name": "Rectangle 811",
    width: 603.758,
    height: 222.965,
    fill: "#b9b9be"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 603.758,
    height: 72.651,
    transform: "translate(0 300.627)",
    fill: "#b9b9be"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1595",
    "data-name": "Group 1595",
    transform: "translate(554.507 1319.835)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_813",
    "data-name": "Rectangle 813",
    width: 603.758,
    height: 72.651,
    fill: "#a0a0a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_814",
    "data-name": "Rectangle 814",
    width: 603.758,
    height: 72.651,
    transform: "translate(0 150.313)",
    fill: "#a0a0a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 603.758,
    height: 72.651,
    transform: "translate(0 300.627)",
    fill: "#a0a0a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4191",
    "data-name": "Path 4191",
    d: "M625.658,1313.326,464.7,1548.817,310,1313.326V155.3A78.3,78.3,0,0,1,388.3,77H547.355a78.3,78.3,0,0,1,78.3,78.3Z",
    transform: "translate(1244.091 307.135)",
    fill: "#ffec00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4192",
    "data-name": "Path 4192",
    d: "M501.334,155.3a78.3,78.3,0,0,0-78.3-78.3H341V1547.9l160.334-234.574Z",
    transform: "translate(1368.414 307.135)",
    fill: "#ffe733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    "data-name": "Path 4193",
    d: "M625.658,155.3a78.3,78.3,0,0,0-78.3-78.3H388.3A78.3,78.3,0,0,0,310,155.3V299.965H625.658Z",
    transform: "translate(1244.091 307.135)",
    fill: "#ffbc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    "data-name": "Path 4194",
    d: "M501.334,155.3a78.3,78.3,0,0,0-78.3-78.3H341V299.965H501.334Z",
    transform: "translate(1368.414 307.135)",
    fill: "#ffa426"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 315.658,
    height: 97.704,
    transform: "translate(1554.091 607.1)",
    fill: "#6861ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 160.334,
    height: 97.704,
    transform: "translate(1709.414 607.1)",
    fill: "#5252d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    "data-name": "Path 4195",
    d: "M327.219,141v915.658l70.136,231.758,72.972-231.758V141Z",
    transform: "translate(1313.146 563.804)",
    fill: "#ffbc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4196",
    "data-name": "Path 4196",
    d: "M341,141V1288.5l1.087-.086,72.972-231.758V141Z",
    transform: "translate(1368.414 563.804)",
    fill: "#ffa426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4197",
    "data-name": "Path 4197",
    d: "M625.658,323.75,464.7,559.241,310,323.75Z",
    transform: "translate(1244.091 1296.712)",
    fill: "#edc85f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4198",
    "data-name": "Path 4198",
    d: "M341,323.75V558.324L501.334,323.75Z",
    transform: "translate(1368.414 1296.712)",
    fill: "#e3b954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4199",
    "data-name": "Path 4199",
    d: "M512.047,342.5H322.317L415.3,484.045Z",
    transform: "translate(1293.487 1371.908)",
    fill: "#6861ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4200",
    "data-name": "Path 4200",
    d: "M341.5,342.5l-.626,141.545L437.621,342.5Z",
    transform: "translate(1367.913 1371.908)",
    fill: "#5252d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sports",
    transform: "translate(11879.813 5353.188)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_488",
    "data-name": "Ellipse 488",
    cx: 979.5,
    cy: 980.5,
    rx: 979.5,
    ry: 980.5,
    transform: "translate(0.431 -0.459)",
    fill: "#5db4e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4201",
    "data-name": "Path 4201",
    d: "M1621.731,769.793,1293.108,441.17,1138.272,399.9,855.256,116.879S107.384,845.634,116.944,855.194l283.02,283.012,41.267,154.844,328.612,328.612c444.76-54.539,797.337-407.1,851.888-851.869Z",
    transform: "translate(328.633 330.291)",
    fill: "#5a80d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1596",
    "data-name": "Group 1596",
    transform: "translate(292.953 294.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4202",
    "data-name": "Path 4202",
    d: "M483.248,426.467a326.249,326.249,0,0,1-56.782,56.786C332.2,557.108,186.408,586.63,77.065,582.014a520.951,520.951,0,0,1,8.672-80.154c33.919.455,181.863-2.09,283.38-75.952A250.706,250.706,0,0,0,425.9,369.122c73.836-101.494,76.408-249.353,75.952-283.38a520.521,520.521,0,0,1,80.154-8.672C582.974,102.872,586.4,294.72,483.248,426.467Z",
    transform: "translate(-76.804 -76.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4203",
    "data-name": "Path 4203",
    d: "M1119.7,564.563l-277.57,277.57L564.559,1119.7A521.373,521.373,0,0,1,259.12,995.239l35.795-72.2-92.6,15.392C114.928,836.615,73.243,708.81,77.262,582.206l36.277-31.619-27.6-48.535A518.857,518.857,0,0,1,202.315,259.1s50.062,9.663,70.33,13.548c19.044,3.536,5.549,5.09-13.548-70.33A519.036,519.036,0,0,1,501.864,85.964a1.119,1.119,0,0,1,.188-.027l47.869,45.672L582.21,77.265c126.6-4.015,254.412,37.666,356.224,125.05l-14.378,65.83,71.188-9.02A521.415,521.415,0,0,1,1119.7,564.563Z",
    transform: "translate(-76.997 -76.997)",
    fill: "#e06426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4204",
    "data-name": "Path 4204",
    d: "M985.187,564.566l-277.57,277.57L138.125,272.644c19.044,3.536,5.549,5.09-13.548-70.33A519.036,519.036,0,0,1,367.344,85.963a1.121,1.121,0,0,1,.187-.027L415.4,131.609l32.289-54.345c126.6-4.015,254.413,37.666,356.224,125.05l-14.378,65.829,71.187-9.02A521.394,521.394,0,0,1,985.187,564.566Z",
    transform: "translate(57.516 -77)",
    fill: "#cf3b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4205",
    "data-name": "Path 4205",
    d: "M655.39,598.609,775.514,718.733l-28.378,28.4-28.4,28.378L598.607,655.391,258.928,995.044q-15.218-13.049-29.5-27.306-14.334-14.34-27.306-29.5L541.8,598.582,426.465,483.249C332.2,557.1,186.408,586.626,77.065,582.01a520.946,520.946,0,0,1,8.672-80.154c33.919.455,181.863-2.09,283.38-75.952l-167-167q12.974-15.138,27.306-29.476T258.9,202.12l167,167c73.836-101.494,76.408-249.353,75.952-283.38a520.523,520.523,0,0,1,80.154-8.672c.107,3.077.268,8.511.268,15.928,0,54.8-8.19,217.443-99.029,333.468L598.577,541.8,938.23,202.12q15.178,12.968,29.5,27.306,14.254,14.26,27.306,29.5Z",
    transform: "translate(-76.804 -76.802)",
    fill: "#eabd3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4206",
    "data-name": "Path 4206",
    d: "M542.841,598.609,662.965,718.733l-28.378,28.4L116.876,229.426q14.334-14.334,29.476-27.306l167,167c73.836-101.494,76.408-249.353,75.952-283.38a520.528,520.528,0,0,1,80.154-8.672c.107,3.077.268,8.511.268,15.928,0,54.8-8.19,217.443-99.029,333.468L486.032,541.8,825.685,202.12q15.178,12.968,29.5,27.306,14.254,14.26,27.306,29.5Z",
    transform: "translate(35.745 -76.802)",
    fill: "#e69022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4207",
    "data-name": "Path 4207",
    d: "M1125.359,394.974c0-76.917-15.366-136.856-41.336-162.827-31.857-31.86-114.931-47.762-217.707-38.9L812.45,246.683l-32.66-40.747c-126.6,26-267.88,87.2-377.269,196.585C293.1,511.937,231.879,653.267,205.908,779.9l44.333,33.893-57,52.5c-8.863,102.8,7.015,185.851,38.9,217.734s114.958,47.762,217.764,38.845l51.107-59.649L536.3,1110.2c126.63-25.967,267.96-87.2,377.35-196.559,109.443-109.443,170.646-250.773,196.612-377.4l-47.949-41.5,60.609-44.869C1124.555,430.819,1125.359,412.453,1125.359,394.974Z",
    transform: "translate(244.762 244.764)",
    fill: "#eabd3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4208",
    "data-name": "Path 4208",
    d: "M966.534,449.883l-60.609,44.869,47.949,41.5c-25.966,126.63-87.169,267.96-196.612,377.4L246.129,402.522C355.518,293.133,496.795,231.934,623.4,205.937l32.661,40.747,53.866-53.437c102.776-8.863,185.85,7.042,217.707,38.9,25.971,25.967,41.336,85.91,41.336,162.827,0,17.478-.8,35.844-2.434,54.907Z",
    transform: "translate(401.153 244.763)",
    fill: "#e69022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4209",
    "data-name": "Path 4209",
    d: "M691.733,448.086a751.477,751.477,0,0,1-12.664,86.366c-91.18,18.362-186.758-10.276-253.421-76.944A282.032,282.032,0,0,1,348.6,204.141a755.154,755.154,0,0,1,86.526-12.691c-24.455,68.868-10.769,151.173,47.333,209.276a201.374,201.374,0,0,0,209.276,47.36Z",
    transform: "translate(675.954 246.559)",
    fill: "#e0e6f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4210",
    "data-name": "Path 4210",
    d: "M534.5,679.049a746.142,746.142,0,0,1-86.392,12.664A201.066,201.066,0,0,0,191.446,435.13a757.846,757.846,0,0,1,12.664-86.393C295,330.486,390.787,358.96,457.5,425.681A280.693,280.693,0,0,1,534.5,679.049Z",
    transform: "translate(246.56 675.924)",
    fill: "#f2f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4211",
    "data-name": "Path 4211",
    d: "M609.143,325.176l-141.973,142-142,141.973-56.786-56.813L410.361,410.362,552.33,268.393Z",
    transform: "translate(464.081 464.083)",
    fill: "#4e5a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4212",
    "data-name": "Path 4212",
    d: "M0,0H200.788V80.33H0Z",
    transform: "translate(874.212 874.612) rotate(-45)",
    fill: "#424b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4213",
    "data-name": "Path 4213",
    d: "M0,0H80.315V240.945H0Z",
    transform: "translate(732.23 902.838) rotate(-45)",
    fill: "#4e5a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4214",
    "data-name": "Path 4214",
    d: "M0,0H80.315V240.945H0Z",
    transform: "translate(845.811 789.284) rotate(-45)",
    fill: "#424b52"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    "data-name": "Path 4174",
    d: "M2042.484,934.051a1233.605,1233.605,0,0,0-6.779-129.366L1439.638,226.876h-378.6L822.139,73.4,48.632,1637.461,598.022,2132.3c95.835,24.183,120.769,22.091,224.117,22.091C1496.117,2154.4,2042.484,1608.029,2042.484,934.051Z",
    transform: "translate(5789.496 296.012)",
    fill: "#6f98b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(5821.71 366.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4160",
    "data-name": "Path 4160",
    d: "M1592.792,671.269V1583.05H23.325l571.022-498.409L23,671.269,807.9,19.154Z",
    transform: "translate(-23 -19.154)",
    fill: "#eab54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4161",
    "data-name": "Path 4161",
    d: "M30.512,27.2H1304.495v988.969H30.512Z",
    transform: "translate(113.296 126.831)",
    fill: "#eeefee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1575",
    "data-name": "Group 1575",
    transform: "translate(244.792 254.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4162",
    "data-name": "Path 4162",
    d: "M35.787,32.449H582.381V65.7H35.787Z",
    transform: "translate(-35.787 -32.449)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4163",
    "data-name": "Path 4163",
    d: "M35.787,41.144h672.5V74.4H35.787Z",
    transform: "translate(-35.787 125.311)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4164",
    "data-name": "Path 4164",
    d: "M76.554,41.144h291.6V74.4H76.554Z",
    transform: "translate(703.882 125.311)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4165",
    "data-name": "Path 4165",
    d: "M35.787,49.838H288.868V83.091H35.787Z",
    transform: "translate(-35.787 283.054)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4166",
    "data-name": "Path 4166",
    d: "M52.979,49.838H795.893V83.091H52.979Z",
    transform: "translate(276.141 283.054)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    "data-name": "Path 4167",
    d: "M35.787,58.533H566.032V91.786H35.787Z",
    transform: "translate(-35.787 440.814)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    "data-name": "Path 4168",
    d: "M68.482,58.533H514.609V91.786H68.482Z",
    transform: "translate(557.425 440.814)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169",
    "data-name": "Path 4169",
    d: "M1107.821,67.228v33.253H35.787V67.228",
    transform: "translate(-35.787 598.575)",
    fill: "#dbd8dd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    "data-name": "Path 4170",
    d: "M75.155,466.59,646.177,965h.325V53.218Z",
    transform: "translate(923.29 598.897)",
    fill: "#f6c863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    "data-name": "Path 4171",
    d: "M594.347,466.59,23.325,965H23V53.218Z",
    transform: "translate(-23 598.897)",
    fill: "#f6c863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    "data-name": "Path 4172",
    d: "M1592.159,573.22H23.017L594.038,74.811h427.1Z",
    transform: "translate(-22.692 990.676)",
    fill: "#eab54e"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600",
    transform: "translate(-18336.451 15424.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-622.068 1605.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    d: "M0,0H3560.169a84.943,84.943,0,0,1,84.943,84.943V1322.834a86.87,86.87,0,0,1-86.87,86.87H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(169.112 0.011)",
    fill: "#fcecdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M10502.191,2163.862v212.075c0,113.34-24.3,219.453-66.843,310.667-85.382,183.552-244.21,306.931-426.053,306.931H4040.83c-39.507,0-71.5-40.1-71.5-89.513v-31.749c0-49.424,32-89.513,71.5-89.513H7679.175a607.74,607.74,0,0,0,51.041-96.156c34.076-80.444,53.332-172.146,53.332-269.513V2147.5a698.622,698.622,0,0,0-14.727-143.467c-16.3-77.6-45.456-148.637-84.382-209.319H4040.83c-39.507,0-71.5-40.1-71.5-89.588v-31.677c0-49.5,32-89.6,71.5-89.6h5998.511c211.382,0,389.676,177.573,445.007,420.181A715.746,715.746,0,0,1,10502.191,2163.862Z",
    transform: "translate(-3969.328 -1583.851)",
    fill: "#07f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M10484.348,2004.032H7768.821c-16.3-77.6-45.456-148.637-84.382-209.319H4040.83c-39.507,0-71.5-40.1-71.5-89.588v-31.677c0-49.5,32-89.6,71.5-89.6h5998.511C10250.723,1583.851,10429.017,1761.424,10484.348,2004.032Z",
    transform: "translate(-3969.328 -1583.851)",
    fill: "#669fe1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M4000.2,1693.75l441.934,23.693L4000.2,1731.717Z",
    transform: "translate(-3831.088 -988.882)",
    fill: "#f4d2b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M4000.2,1728.238l1051.38,23.686L4000.2,1766.2Z",
    transform: "translate(-3831.088 -802.191)",
    fill: "#f4d2b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(52.502 3014.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    d: "M0,0H3478.474a82.038,82.038,0,0,1,82.038,82.038v937.427a77.037,77.037,0,0,1-77.037,77.037H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(3560.512 1096.503) rotate(180)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    d: "M0,0H3904.459a80.1,80.1,0,0,1,80.1,80.1v938.074a78.326,78.326,0,0,1-78.326,78.326H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(6956.349 1096.503) rotate(180)",
    fill: "#fcecdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 4468.821,
    height: 163.992,
    rx: 11.896,
    transform: "translate(7141.179 1096.502) rotate(180)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 4468.821,
    height: 163.992,
    rx: 11.896,
    transform: "translate(7141.179 163.992) rotate(180)",
    fill: "#d38888"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M5498.32,1888.66l-483.1,18.437,483.1,11.109Z",
    transform: "translate(1458.041 -1340.406)",
    fill: "#f4d2b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M6042.922,1849.316l-1149.3,18.44,1149.3,11.1Z",
    transform: "translate(913.444 -1553.407)",
    fill: "#f4d2b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(5818.904 310.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M4895.781,1851.621s49.239,47.112,65.546,124.55a235.183,235.183,0,0,1,5.11,43.322c2.715,102.894,0,335.759,0,335.759l145.422-116.428,145.04,116.428V2039.646c0-59.685-12.454-117.733-35.562-155.751-11.2-18.419-24.773-32.274-40.179-32.274Z",
    transform: "translate(-4895.781 -1851.621)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M4895.781,1851.621s49.239,47.112,65.546,124.55l291.4,4.614s-11.431-110.882-71.57-129.164Z",
    transform: "translate(-4895.781 -1851.621)",
    fill: "#568cdb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    d: "M0,0H3475.355a89.806,89.806,0,0,1,89.806,89.806V1519.161A91.842,91.842,0,0,1,3473.319,1611H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(165.377)",
    fill: "#fcecdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M7556.346,1958.193v346.713c-.753,148.07-59.38,276.558-145.527,345.253-42.421,33.694-91.425,52.975-143.51,52.975H3895.6c-39.507,0-71.557,44.8-71.557,100.048v40.9c0,55.241,32.051,100.04,71.557,100.04H9720.268c167.148,0,314.811-116.164,404.021-293.968,56.274-112.035,89.289-248.457,89.289-395.8V1980.792c0-100.933-16.509-196.519-46-281.656-74.9-216.617-233.533-365.987-417.178-365.987H3895.6c-39.507,0-71.557,44.713-71.557,99.961v40.9c0,55.248,32.051,100.044,71.557,100.044H7277.609c80.828,0,153.989,48.116,205.093,125.077C7527.954,1767.34,7555.882,1858.149,7556.346,1958.193Z",
    transform: "translate(-3824.039 -1333.107)",
    fill: "#ffd878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M3824.039,1691.507v40.908c0,55.248,32.051,100.048,71.557,100.048H9720.268c167.148,0,314.811-116.172,404.021-293.979H7410.818c-42.421,33.694-91.425,52.979-143.51,52.979H3895.6C3856.09,1591.464,3824.039,1636.267,3824.039,1691.507Z",
    transform: "translate(-3824.039 -221.431)",
    fill: "#e3b84d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M3854.234,1458.726l432.225,27.071-432.225,16.319Z",
    transform: "translate(-3688.86 -653.221)",
    fill: "#f4d2b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M3854.234,1400.922l1028.315,27.086L3854.234,1444.32Z",
    transform: "translate(-3688.86 -966.168)",
    fill: "#f4d2b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(685.519 456.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M4446.758,1404.308s-67.86,51.086-90.332,135.053a204.38,204.38,0,0,0-7.042,46.978c-3.747,111.555,0,364.051,0,364.051l-200.377-126.241L3949.172,1950.39V1608.179c0-64.71,17.145-127.65,48.986-168.873,15.442-19.961,34.161-35,55.356-35Z",
    transform: "translate(-3949.172 -1404.308)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M4442.089,1404.308s-67.866,51.086-90.351,135.053l-401.52,5s15.763-120.236,98.621-140.057Z",
    transform: "translate(-3944.494 -1404.308)",
    fill: "#ed7d2b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1599",
    "data-name": "Group 1599",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, -11104.901, 9154.002)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M2372.188,5776.846l-196.467,135.088S1230.883,4904.865,1002.775,3939.5c-40.655-172.356-57.136-342.35-39.71-503.627,0,0-13.79-43.719-37.917-121.02-1.073-3.377-2.147-6.859-3.224-10.327-10.557-33.914-23.229-73.8-37.295-118.981C838.829,3039.678,775.9,2840.068,704.2,2612.8,539.07,2089.8,161.376,910.308,0,419.674L1159.925,0s131.756,300.447,321.081,1117.056c29.147,106.578,58.385,224.447,85.657,352.861,30.944,145.45,59.8,304.493,83.841,476.319,40.686,291.063,67.842,618.548,69.525,977.759.646,146.1-2.927,297.622-11.6,453.952-6.329,114.635,10.689,267.391,42.65,441.156C1897.222,4613.588,2372.188,5776.846,2372.188,5776.846Z",
    transform: "translate(1560.28 4583.104)",
    fill: "#2b478b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M1650.5,1946.235,921.924,3304.528c-10.557-33.914-23.229-73.8-37.295-118.981C838.829,3039.678,775.9,2840.068,704.2,2612.8,539.07,2089.8,161.376,910.308,0,419.674L1159.925,0s131.756,300.447,321.081,1117.056c29.147,106.578,58.385,224.447,85.657,352.861C1597.607,1615.367,1626.465,1774.409,1650.5,1946.235Z",
    transform: "translate(1560.28 4583.104)",
    fill: "#233862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1408.4,244.782s-1.134,10.132-3.133,29.431c-.876,8.284-2.013,18.329-3.234,30.033-8.3,77.45-24.015,226.045-44.276,419.273-52.91,506.776-135.946,1320.71-192.521,1963.167-44.274,502.312-72.381,899.859-57.193,963.666,45.662,192.1,0,2488.447,0,2488.447-163.887,78.6-412.379,0-412.379,0S259.106,4069.473,320.218,3781.857s-40.86-533.135-40.86-533.135C-59.6,1670.172-22.494,795.28,44.824,376.446c19.559-121.8,41.751-205,57.984-255.738,13.7-43.135,23.229-62.855,23.229-62.855C873.7-143.329,1408.4,244.782,1408.4,244.782Z",
    transform: "translate(810.804 4455.609)",
    fill: "#2b478b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M11.231,351.57S296.5,295.59,315.985,155.558c19.437-140.032-12.973-182,77.793-140.032,90.766,42.025,486.239,70.041,706.69,35.047,220.4-35.047,19.436,104.985-25.947,147.01-45.383,41.975-933.606,441.03-933.606,441.03S-47.124,582.58,11.231,351.57Z",
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 1695.233, 10495.04)",
    fill: "#2f3655"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M10.517,316.335s267.124-50.37,285.368-176.367c18.2-126-12.148-163.763,72.845-126C453.721,51.783,824.037,76.991,1030.465,45.5c206.384-31.534,18.2,94.463-24.3,132.276-42.5,37.768-874.216,396.829-874.216,396.829S-44.126,524.192,10.517,316.335Z",
    transform: "matrix(0.956, 0.292, -0.292, 0.956, 3743.124, 10417.816)",
    fill: "#2f3655"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 0, 348.546)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M1183.943,1326.831S700.821,2156.924,537.51,2190.962C374.237,2224.964,0,1918.8,0,1918.8L81.655,0s367.43,40.81,435.469,278.967S537.51,1551.374,537.51,1551.374l551.162-326.621Z",
    transform: "translate(2349.081 1415.392)",
    fill: "#2c5099"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M256.824,196.214S469.508,71.077,612.4,71.077,1198.877,0,1198.877,0l638.271,71.077s704.262,224.542,734.9,316.409c30.6,91.866-102.078,1265.6-173.522,1439.084-71.444,173.521,88.169,2163.167,88.169,2163.167L0,3735.2S244.966,2571.64,295.987,2275.654C347.044,1979.669,256.824,196.214,256.824,196.214Z",
    transform: "translate(236.334 1225.217)",
    fill: "#4e6fd8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(236.334 1255.485)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M320.582,650.9s534.875,490.809,915.151,368.93c36.527-317.1,60.353-617.922,45.458-662.61-30.635-91.867-734.9-316.409-734.9-316.409L15.591,0S9.224.476,0,1.135Z",
    transform: "translate(1290.853 0)",
    fill: "#231f20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M731.456,2454.776c122.5-170.118,884.554-626.01,884.554-626.01l183.733-830.129s-741.667,272.2-870.939-6.807c-129.272-278.967,81.655-687.206-251.772-836.9C587.69,114.815,501.534,59.4,422.88,0c-19.471,411.13-84,1719.478-126.893,1968.249C244.966,2264.235,0,3427.792,0,3427.792L1161.947,2948.4C927.194,2778.688,659.939,2554.109,731.456,2454.776Z",
    transform: "translate(0 277.137)",
    fill: "#231f20"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M31.753,266.227S72.6,41.684,246.084,11.05c173.521-30.635,387.852,0,336.831,122.464-51.057,122.5-295.986,81.655-295.986,81.655S103.2,460.134,31.753,409.114C-39.691,358.057,31.753,266.227,31.753,266.227Z",
    transform: "translate(2143.806 2254.858)",
    fill: "#fed4d5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M532.32,59.64S818.094-144.48,960.981,202.527c142.923,347.007-71.444,1500.353-71.444,1500.353L2216.4,1022.445l139.483,227.946S858.94,3029.71,266.968,2366.295,205.736,202.527,532.32,59.64Z",
    transform: "translate(0 1338.733)",
    fill: "#4e6fd8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M910.281,551.224,957.9,401.53S815.01,340.3,767.393,258.643,617.7,6.906,393.156.1-69.544,340.3,18.919,612.457c88.462,272.2,421.854,68.04,421.854,68.04S862.663,762.152,910.281,551.224Z",
    transform: "translate(1704.151 0)",
    fill: "#2f3655"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M438.874,0,0,510.316s163.311,724.648,489.931,663.415C816.514,1112.5,632.818,816.514,632.818,816.514l204.12-306.2Z",
    transform: "translate(1348.834 734.958)",
    fill: "#fed4d5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M806.85,270.938,684.2,328.181,0,1403.443l883.072-310.358L1634.429,0Z",
    transform: "translate(2364.683 2019.687)",
    fill: "#1c468a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M510.061,510.316,112,0,0,130.26C3.4,379.032,27.561,946.883,172.058,1171.426c313.078-65.258,133.883-354.912,133.883-354.912Z",
    transform: "translate(1675.71 734.958)",
    fill: "#231f20",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M265.388,165.371S204.156-72.751,74.848,22.483c-129.272,95.27,0,272.2,0,272.2L0,423.951S272.2,430.758,265.388,165.371Z",
    transform: "translate(3417.33 2365.889)",
    fill: "#fed4d5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M82.558,387.853S-80.715,122.465,51.96,71.444,215.27,255.177,215.27,255.177,398.967,173.522,409.178,0c0,0,357.218,347.007,510.317,132.676,0,0-91.867,857.36-449.085,785.916S82.558,632.781,82.558,387.853Z",
    transform: "translate(1694.937 418.549)",
    fill: "#fed4d5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M545.935,2315.915C-183.434,2190.377,421.238,426.466,578.8,0,550.034,13.652,532.32,26.279,532.32,26.279,205.736,169.166-325,1669.518,266.968,2332.934c205.584,230.4,518.332,162.578,838.95-23.717C930.164,2340.766,741.123,2349.514,545.935,2315.915Z",
    transform: "translate(0 1372.094)",
    fill: "#231f20",
    opacity: 0.46,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1601",
    "data-name": "Group 1601",
    transform: "translate(-10909.169 18677.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path774",
    d: "M574.664,27.592V4991.339c0,202.81,164.446,367.255,367.4,367.255H3117.321c203.011,0,367.405-164.445,367.405-367.255V27.59c0-202.811-164.394-367.257-367.405-367.257H942.069c-202.962,0-367.4,164.446-367.4,367.257",
    transform: "translate(3909.994 -3706.328)",
    fill: "#41598f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path776",
    d: "M574.664,9.836V4733.359c0,192.981,164.446,349.453,367.4,349.453H3117.321c203.011,0,367.405-156.471,367.405-349.453V9.836c0-193.03-164.394-349.5-367.405-349.5H942.069c-202.962,0-367.4,156.471-367.4,349.5",
    transform: "translate(3909.994 -3706.327)",
    fill: "#4d65a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path778",
    d: "M808.1-334.948h2084.88a227.393,227.393,0,0,1,161.588,66.953,227.445,227.445,0,0,1,67,161.637v4400a228.668,228.668,0,0,1-228.587,228.587H808a228.412,228.412,0,0,1-228.437-228.437V-106.358a227.725,227.725,0,0,1,66.953-161.637A227.377,227.377,0,0,1,808.1-334.948",
    transform: "translate(4089.25 -3533.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path780",
    d: "M2794.178,960.644H686.481A103.9,103.9,0,0,1,582.568,856.731V-218.707A103.9,103.9,0,0,1,686.481-322.62h2107.7a103.945,103.945,0,0,1,103.963,103.913V856.731a103.945,103.945,0,0,1-103.963,103.913",
    transform: "translate(4199.383 -3082.191)",
    fill: "#86a9d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path782",
    d: "M818.824-205.457A91.124,91.124,0,0,1,727.7-114.334a91.09,91.09,0,0,1-91.123-91.124A91.079,91.079,0,0,1,727.7-296.531a91.114,91.114,0,0,1,91.124,91.074",
    transform: "translate(6176.794 -2127.026)",
    fill: "#e0e1de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path786",
    d: "M585.277-205.457A91.091,91.091,0,0,0,676.4-114.334a91.168,91.168,0,0,0,91.174-91.124A91.154,91.154,0,0,0,676.4-296.531a91.081,91.081,0,0,0-91.124,91.074",
    transform: "translate(4298.531 -2127.026)",
    fill: "#e0e1de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path790",
    d: "M1043.634-60.692,607.871-312.249V190.918Z",
    transform: "translate(5125.746 -2702.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path792",
    d: "M2898.142-281.8H582.568V-91.877H2898.142V-281.8",
    transform: "translate(4199.383 -1587.59)",
    fill: "#d6dfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path794",
    d: "M2898.142-269.756H582.568V-79.885H2898.142V-269.756",
    transform: "translate(4199.383 -1146.669)",
    fill: "#d6dfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path796",
    d: "M2898.142-257.714H582.568V-67.843H2898.142V-257.714",
    transform: "translate(4199.383 -705.797)",
    fill: "#d6dfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path798",
    d: "M2898.142-245.673H582.568V-55.8H2898.142V-245.673",
    transform: "translate(4199.383 -264.924)",
    fill: "#d6dfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path800",
    d: "M2898.142-233.632H582.568V-43.709H2898.142V-233.632",
    transform: "translate(4199.383 175.948)",
    fill: "#d6dfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path802",
    d: "M2898.142-221.589H582.568V-31.717H2898.142V-221.589",
    transform: "translate(4199.383 616.869)",
    fill: "#d6dfe3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604",
    transform: "translate(-21338.076 12634.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M2205.29,1442.183c163.553,289.383,371.047,402.087,371.047,402.087l866.47,6.121S2080.516,1221.428,2205.29,1442.183Z",
    transform: "translate(355.296 2613.752)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M2908.271,2292.048c22.389,26.04,25.073,54.976,13.68,85.769a.663.663,0,0,1-.237.429c-21.066,56.965-89.789,120.257-169.548,183.377-10.176,8.12-19.253,15.485-27.165,22.325-2.069,1.792-4.135,3.581-6.085,5.394-1.614,1.395-3.171,2.843-4.705,4.177-74.43,67.648-46.712,83.458-180.544,220.862-152.618,156.559-256.941,158.675-286.511,144.1-25.025-12.423,26.571-95.658,83.744-189.221,2.777-4.511,5.48-9.088,8.341-13.649,7.6-12.437,15.179-25.07,22.728-37.566,67.041-112.618,50.4-165.814,35.9-334.213-11.8-136.856-207.385-765.568-207.385-765.568l290.668-47.956s83.914,500.124,179.7,577.729c51.225,41.376,108.887,42.289,158.181,73.034,3.481,2.141,6.912,4.33,10.252,6.582C2857.29,2246.506,2885.806,2265.946,2908.271,2292.048Z",
    transform: "translate(302.066 3998.473)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M2863.71,1714.334c22.389,26.04,25.079,54.971,13.686,85.772a.668.668,0,0,1-.23.423c-25.71,56.886-92.716,119.86-169.821,182.806-10.073,8.244-18.968,15.819-26.882,22.906-2.085,1.792-4.148,3.583-6.111,5.389-1.6,1.395-3.158,2.852-4.705,4.177-74.421,67.648-46.712,83.467-180.532,220.871-152.63,156.557-256.948,158.665-286.524,144.1-25.009-12.439,26.588-95.668,83.76-189.231,29.566-10.6,166.945-65.283,271.457-197.083,92.04-115.766,153.944-264.909,216.658-351.107,3.485,2.14,6.922,4.33,10.247,6.585C2812.738,1668.791,2841.257,1688.235,2863.71,1714.334Z",
    transform: "translate(346.623 4576.183)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M2781.282,2184.887c-18.545,89.488-146.177,73.641-288.654,37.757s-108.84,5.823-311.8-18.108c-202.962-23.913-263.953-100.08-269.939-130.325-5.359-26.837,95.067-35.585,202.808-47.223,13.549-1.424,27.152-3,40.774-4.583,121.642-14.388,211.209-92.194,322.054-155.824,105-60.281,262.819-307.745,262.819-307.745l278.407,24.029s-147.743,220.988-204.97,317.12c-33.647,56.54-32.411,131.632-28.679,189.631C2786.041,2121.147,2787.87,2153.364,2781.282,2184.887Z",
    transform: "translate(-1910.686 3907.791)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M2492.628,1807.049c-142.471-35.886-108.84,5.818-311.8-18.111-202.962-23.907-263.953-100.084-269.939-130.325-5.359-26.839,95.067-35.585,202.808-47.224l.993,2.082s121.2,87.218,290.249,92.472c137.775,4.316,284.022-34.134,379.163-31.925,1.938,31.531,3.767,63.752-2.822,95.269C2762.737,1858.776,2635.105,1842.929,2492.628,1807.049Z",
    transform: "translate(-1910.686 4323.39)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M2129.656,1824.046l255.461,702.537L2718.639,3443.9s92.185,9.556,180.708-15.233c81.5-22.939,175.275-83.79,175.275-83.79s-87.473-983.023-259.584-1548.191c-44.1-145.056-93.866-262.5-149.207-328.789C2395.124,1143.345,2129.656,1824.046,2129.656,1824.046Z",
    transform: "translate(-178.978 2495.013)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M3542.422,1415.111c170.971-53.821,657.062,20.27,1145.164,119.4l103.526-168.077,1056.307-75.005s342.921,775.02,148.726,1265.942c-28.551,72.145-98.148,102.173-193.11,103.028l-.105.131s-630.083,10.945-834.118,9.513c-525.026-3.711-1108.6-368.75-1184.3-384.454-123.935-25.694-175.343,222.164-301.28,481.9S2308.511,3913.423,2308.511,3913.423s-160.225.463-226.234-24.83c-70.993-27.193-96.79-62.046-96.79-62.046S3156.824,1536.493,3542.422,1415.111Z",
    transform: "translate(-1319.137 1793.005)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M2542.829,2650.771c374.487,209.645,1134.133,644.141,1138.1,641.4,0,0,279.576,107.616,439.369,3.112,266.294-174.167,411.766-646.9-70.09-1058.027-240.308-205.04-411.705-255.746-435.528-580.6-12.908-176.244-249.587-759.264-650.034-708.326-33.464,4.263-67.153,7.242-100.88,5.914a374.468,374.468,0,0,0-203.359,50.99C2433.044,1138.434,1979.8,2566.668,2542.829,2650.771Z",
    transform: "translate(945.602 -945.19)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M2377.542,1639.653c-1.653,1.059,184.522,66.093,309.707,11.708,117.744-51.057,208.042-243.574,206.3-243.687-53.383-2.836-111.681-49.947-154.658-356.629l-22.809,8-383.32,134.883s26.834,122.885,43.929,239.815C2391.09,1531.924,2398.527,1625.934,2377.542,1639.653Z",
    transform: "translate(1427.226 -108.05)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M2332.758,1186.829s16.341,86.111,39.012,209.185c219.893-37.977,312.558-225.552,344.309-344.071Z",
    transform: "translate(1427.226 -100.947)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M2560.756,1896.471s523.633-66.521,477.177-391.973-10.15-553.221-346.426-524.5-383.378,162.143-394.278,274.54C2286.292,1366.943,2423.362,1905.391,2560.756,1896.471Z",
    transform: "translate(1141.413 -689.219)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M2298.967,1102.345s332.842,290.95,560.463,315.823,314.38-47.631,314.38-47.631-133.486-112.424-213.016-292.9c-23.449-53.192-73.489-89.936-131.37-95.346C2666.871,967.1,2358.583,958.521,2298.967,1102.345Z",
    transform: "translate(1160.005 -715.092)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M2563.567,1042.244s-112.808,107.533-148.649,187.62c-34.6,77.3-46.113,262.654-19.528,336.5,0,0-172.143-340.628-72.172-504.838C2429.244,887.406,2563.567,1042.244,2563.567,1042.244Z",
    transform: "translate(1104.922 -679.363)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M2287.753,2101.743c8.337,1059.049-1.569,837.7,113.555,939,27.741,24.389,106.1,39.364,209.326,46.91,324.559,23.843,895.736-25.624,917.859-85.479,76.349-207.1,23.936-271.984,88.67-589.421,6.752-33.756,15.077-70.3,24.807-110.084,53.643-217.976,104.887-291.884-77.477-643.955C3399.1,1339.8,3226.8,1080.7,3211.06,1089.9c-444.093,259.406-478.208,38.5-478.208,38.5S2283.634,1585.17,2287.753,2101.743Z",
    transform: "translate(1071.082 197.373)",
    fill: "#99cdd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M2158.332,2156.839l333.5,917.321s92.21,9.561,180.73-15.233c81.5-22.941,175.266-83.791,175.266-83.791s-87.466-983.025-259.577-1548.188Z",
    transform: "translate(47.798 2864.751)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M3125.859,1094s-455.6,73.947-510.43,269.484-377.4,1345.146-377.4,1345.146,231.055,43.2,338.681-62.919,378.852-988.878,378.852-988.878Z",
    transform: "translate(678.07 231.69)",
    fill: "#99cdd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M2323.973,2305.568c324.552,23.843,895.733-25.63,917.859-85.481,76.349-207.1,23.929-271.98,88.661-589.419l-153.5-442.112s22.427,491.262-123.3,619.414c-145.6,128.152-594.732,245.156-665.9,352.586C2353.465,2212.114,2330.76,2263.9,2323.973,2305.568Z",
    transform: "translate(1357.74 979.452)",
    fill: "#82b3b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M2870.24,1337.139s-319.851-73.59-371.739-45.535c-51.878,28.075-178.956,130.708-195.022,166.627s115.274-26.541,157.922-37.66c27.629-7.192,100.012,18.536,135.866,30.766,150.846,51.465,243.656,26.2,243.656,26.2Z",
    transform: "translate(1184.98 1743.963)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M2639.573,1089.663s429.956,29.531,577.4,238.268c207.545,293.833,614.545,1542.679,375.073,1707.175-269.683,185.237-1221.736,40.324-1221.736,40.324s-30.694-148.456,13.949-219.851,762.541-182.176,795.858-215.04-409.143-648.287-408.444-747.577C2772.39,1793.667,2639.573,1089.663,2639.573,1089.663Z",
    transform: "translate(1642.832 197.368)",
    fill: "#99cdd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M2434.286,1295.939s-67.729,86.1-89.814,96.286-36.267,7.5-36.267,7.5l45.806-81.1Z",
    transform: "translate(1233.062 1828.686)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M2498,1285.942l-195.813,93.4s8.193,13.641,32.241,12.712,84.8-22.658,84.8-22.658Z",
    transform: "translate(1185.486 1749.621)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(1619.381 2191.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M4092.378,2360.148l-1543.691-10.9-456.22-1158.032,1541.315,10.874Z",
    transform: "translate(-2092.467 -1191.219)",
    fill: "#4d65a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M2141.684,1316.146l2038.439,14.386-.3,44.99-2020.365-14.248Z",
    transform: "translate(-1703.246 -203.239)",
    fill: "#41598f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M2190.4,1321.619c-11.361-40.666,12.341-73.4,52.932-73.119s82.7,33.5,94.058,74.166-12.344,73.414-52.942,73.133C2243.872,1395.515,2201.749,1362.3,2190.4,1321.619Z",
    transform: "translate(-1340.431 -738.225)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolisticApplication);
export default __webpack_public_path__ + "static/media/holisticApplication.0857e4cab55ba036c00dbe6cd73f2160.svg";
export { ForwardRef as ReactComponent };